import { Footer } from '@cox/core-ui8/dist/Footer'

import { ReactFooterProps } from './types'
import withAEM from '../../hoc/withAEM'

const ReactFooter = (props: ReactFooterProps) => {
  const FooterWithAEM = withAEM(Footer)
  return <FooterWithAEM {...props} compName={'Footer'} atomSpacing={true} />
}

export default ReactFooter
